/**
 * Käyttäjäroolit
 */
export type UserRole = "admin" | "installer" | "partner";

/**
 * Käyttäjä rooleineen ja partner-tietoineen
 */
export interface UserWithRole {
  id: string;
  email: string;
  created_at: string;
  email_confirmed_at: string | null;
  first_name: string | null;
  last_name: string | null;
  role: UserRole | null;
  partner_id: string | null;
  partner_name: string | null;
}

/**
 * Uuden käyttäjän kutsupyyntö
 */
export interface InviteUserRequest {
  email: string;
  firstName?: string;
  lastName?: string;
  role: UserRole;
  partnerId?: string;
}

/**
 * Roolin päivityspyyntö
 */
export interface UpdateRoleRequest {
  role: UserRole;
  partnerId?: string | null;
}

/**
 * Roolien suomenkieliset nimet
 */
export const ROLE_LABELS: Record<UserRole, string> = {
  admin: "Ylläpitäjä",
  installer: "Asentaja",
  partner: "Partneri",
};

/**
 * Roolien värikoodit (Tailwind-luokat)
 */
export const ROLE_COLORS: Record<UserRole, string> = {
  admin: "bg-primary text-primary-foreground",
  installer: "bg-blue-500 text-white",
  partner: "bg-amber-500 text-white",
};
